import React from 'react';
import { formatTimestamp } from '../../utils/helpers';
import './AiLogPanel.css';

const TYPE_COLORS = {
  trade_decision: '#888',
  quick_scan: '#22c55e',
  deep_analysis: '#22c55e',
  self_reflection: '#22c55e',
  reactive_commentary: '#f59e0b',
};

function getIconColor(decision) {
  if (decision.error) return '#ef4444';
  return TYPE_COLORS[decision.type] || '#888';
}

function buildActionSummary(action) {
  if (!action) return '';
  if (action.action === 'open_long' || action.action === 'open_short') {
    return `Open ${action.action.replace('open_', '')} ${action.symbol || ''} ${action.leverage ? action.leverage + 'x' : ''}`.trim();
  }
  if (action.action === 'close') {
    return `Close ${action.symbol || ''}`.trim();
  }
  if (action.action === 'hold') {
    return 'Hold';
  }
  return '';
}

function DiamondIcon({ color }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M8 1L15 8L8 15L1 8L8 1Z"
        fill={color}
        fillOpacity="0.2"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

function AiLogPanel({ decisions, connectionStatus }) {
  const isLive = connectionStatus === 'connected';

  return (
    <div className="ai-log-panel" data-tour="ai-log-panel">
      {/* Header */}
      <div className="ai-log-header">
        <img
          src="/assets_new/img/deepseek-logo.svg"
          alt="DeepSeek"
          className="ai-log-header-icon"
        />
        <span className="ai-log-header-title">DeepSeek AI Log</span>
        <span className={`ai-log-live-dot ${isLive ? '' : 'offline'}`} />
        <span className={`ai-log-live-label ${isLive ? '' : 'offline'}`}>
          {isLive ? 'Live' : 'Offline'}
        </span>
      </div>

      {/* Messages */}
      {!decisions || decisions.length === 0 ? (
        <div className="ai-log-empty">No AI decisions yet</div>
      ) : (
        <div className="ai-log-messages">
          {decisions.map((d) => {
            const iconColor = getIconColor(d);
            const actionSummary = buildActionSummary(d.action);
            const reasoning = d.reasoning || '';

            return (
              <div key={d._id} className="ai-log-message">
                <div className="ai-log-icon">
                  <DiamondIcon color={iconColor} />
                </div>
                <div className="ai-log-body">
                  {actionSummary && (
                    <div className={`ai-log-action action-${d.action?.action || ''}`}>
                      {actionSummary}
                    </div>
                  )}
                  {reasoning && (
                    <div className="ai-log-text">{reasoning}</div>
                  )}
                  <div className="ai-log-time">{formatTimestamp(d.createdAt)}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AiLogPanel;
